import React from 'react';
import { useTranslation } from 'react-i18next';
import Badge, { BadgeType } from 'src/components/ui/Badge/Badge';
import { WorkflowRunStep } from 'src/services/workflows';

const STEP_BADGE: Record<WorkflowRunStep['status'], BadgeType> = {
  passed: BadgeType.Successful,
  failed: BadgeType.Warning,
  executed: BadgeType.Successful,
  would_execute: BadgeType.Neutral4,
};

interface WorkflowStepsProps {
  steps: WorkflowRunStep[];
}

const WorkflowSteps: React.FC<WorkflowStepsProps> = ({ steps }) => {
  const { t } = useTranslation();
  if (!steps.length) return null;
  return (
    <ol className="flex flex-col gap-y-6">
      {steps.map((step, index) => (
        <li key={`${step.item_id ?? index}-${step.status}`} className="flex items-center gap-x-10">
          <span className="typo-text-12 text-faded w-[16px] shrink-0">{index + 1}.</span>
          <span className="typo-text-12 text-faded shrink-0">{t(`workflows.node_label_${step.item_type}`)}</span>
          <span className="typo-text-12 text-full truncate">{step.label}</span>
          <Badge
            expanded
            showDot
            dotFilled
            className="ml-auto shrink-0"
            type={STEP_BADGE[step.status]}
            label={t(`workflows.step_status.${step.status}`)}
          />
        </li>
      ))}
    </ol>
  );
};

export default WorkflowSteps;
